export default __webpack_public_path__ + "static/media/logo-hello.2f83e118.jpg";